import { getField, updateField } from 'vuex-map-fields';

import {
  RestHelper,
} from './helpers/RestHelpers';

const helper = new RestHelper('contacts', 'contacts');

export default {
  namespaced: true,
  state: {
    ...helper.defaultState(),
    response: {},
  },
  mutations: {
    updateField,
    ...helper.mutations,
  },
  actions: {
    ...helper.actions,
    searchForForm({ commit, rootGetters }, query = '') {
      return new Promise((resolve, reject) => {
        commit(
          'api/fetch',
          {
            url: '/contacts/search',
            params: {
              fulltext: query,
              per_page: 100,
              view: 'overview',
              notrack: true,
            },
            method: 'GET',
            headers: rootGetters['auth/getHeaders'],
            promise: {
              resolve,
              reject,
            },
          },
          { root: true },
        );
      });
    },
    search({ commit, rootGetters }, { query, countryCode, searchBy }) {
      return new Promise((resolve, reject) => {
        commit(
          'api/fetch',
          {
            url: '/services/merk-suggestions',
            method: 'POST',
            headers: rootGetters['auth/getHeaders'],

            body: {
              country: countryCode,
              query,
              search_by: searchBy,
            },
            promise: {
              resolve,
              reject,
            },
          },
          { root: true },
        );
      });
    },
    getResponse({ state }, response) {
      const { contact, contact_id: contactId } = response.payload.data;

      state.response = {
        company_number: contact.company_number,
        id: contactId,
        name: contact.name,
        web: contact.web,
      };
    },
  },
  getters: {
    getField,
    response: state => state.response,
    ...helper.getters,
  },
};
